module.exports = __webpack_public_path__ + "img/logo.8b26e772.png";